module.exports = __webpack_public_path__ + "static/media/farmers-trio.70a72ccd.svg";